const API_KEY = '7FD3BF44-717B-450D-B196-40EEA5FC6ABD';
export default API_KEY;
